import React from "react";
import { useIsMobile } from "../../Hooks";
import { CAROUSEL_IMAGES } from "../../Constants";
import { FmMobileHeader, LeftIconStyle } from "../FmMobileHeader";
import { FmSimpleCarusel } from "../FmSimpleCarusel";
import useStyles from "./FmGalleryLayout.style";

interface FmGalleryLayoutProps {
    children?: React.ReactNode;
    mobileHeaderRightButtonText?: string;
    mobileHeaderRightButtonOnClick?: () => void;
    mobileLeftButtonIconStyle?: LeftIconStyle;
    mobileLeftButtonIconOnClick?: () => void;
    showMobileHeaderShadow?: boolean;
}

const FmGalleryLayout = ({
    children,
    mobileHeaderRightButtonText,
    mobileHeaderRightButtonOnClick,
    mobileLeftButtonIconStyle,
    mobileLeftButtonIconOnClick,
    showMobileHeaderShadow,
}: FmGalleryLayoutProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();

    const renderContent = () => {
        return isMobile ? (
            <div className={classes.contentContainer}>{children}</div>
        ) : (
            <>
                <div className={classes.desktopContainer}>
                    <div className={classes.leftSide}>
                        <div className={classes.contentContainer}>{children}</div>
                    </div>
                    <div className={classes.rightSide}>
                        <FmSimpleCarusel data={CAROUSEL_IMAGES} />
                    </div>
                </div>
            </>
        );
    };

    return (
        <div className={classes.container}>
            {isMobile && (
                <FmMobileHeader
                    rightButtonText={mobileHeaderRightButtonText}
                    rightButtonOnClick={mobileHeaderRightButtonOnClick}
                    leftIconStyle={mobileLeftButtonIconStyle}
                    onLeftButtonClick={mobileLeftButtonIconOnClick}
                    addShadow={showMobileHeaderShadow}
                />
            )}
            {renderContent()}
        </div>
    );
};

export default FmGalleryLayout;
